/**
 * Uzbek Cyrillic -> Uzbek Latin transliteration.
 *
 * Official Latin alphabet mapping (O'zbekiston Respublikasining lotin
 * alifbosi, 1993/1995). Apostrophe is ASCII U+0027 "'" — the same token the
 * dashboard.* uz-Latn keys already use.
 *
 * Used by:
 *  - I18nContext.t() so uz-Latn falls back to a transliterated uz-Cyrl value.
 *  - ContentTransliterator so hardcoded uz-Cyrl strings render in Latin
 *    without requiring every call site to be migrated to a translation key.
 */

const CYRILLIC_TO_LATIN: Record<string, string> = {
  "А": "A", "а": "a",
  "Б": "B", "б": "b",
  "В": "V", "в": "v",
  "Г": "G", "г": "g",
  "Ғ": "G'", "ғ": "g'",
  "Д": "D", "д": "d",
  "Е": "E", "е": "e",
  "Ё": "Yo", "ё": "yo",
  "Ж": "J", "ж": "j",
  "З": "Z", "з": "z",
  "И": "I", "и": "i",
  "Й": "Y", "й": "y",
  "К": "K", "к": "k",
  "Қ": "Q", "қ": "q",
  "Л": "L", "л": "l",
  "М": "M", "м": "m",
  "Н": "N", "н": "n",
  "О": "O", "о": "o",
  "Ў": "O'", "ў": "o'",
  "П": "P", "п": "p",
  "Р": "R", "р": "r",
  "С": "S", "с": "s",
  "Т": "T", "т": "t",
  "У": "U", "у": "u",
  "Ф": "F", "ф": "f",
  "Х": "X", "х": "x",
  "Ҳ": "H", "ҳ": "h",
  "Ц": "Ts", "ц": "ts",
  "Ч": "Ch", "ч": "ch",
  "Ш": "Sh", "ш": "sh",
  "Щ": "Sh", "щ": "sh",
  "Ъ": "'", "ъ": "'",
  "Ы": "I", "ы": "i",
  "Ь": "'", "ь": "'",
  "Э": "E", "э": "e",
  "Ю": "Yu", "ю": "yu",
  "Я": "Ya", "я": "ya",
};

const CYRILLIC_RE = /[\u0400-\u04FF]/;

/**
 * Transliterates a Cyrillic Uzbek string to Latin Uzbek.
 * Any non-Cyrillic characters (latin, digits, punctuation) are preserved
 * as-is, which keeps the operation idempotent.
 */
export function toUzbekLatin(text: string): string {
  if (!text || !CYRILLIC_RE.test(text)) return text;
  let out = "";
  for (const ch of text) {
    const mapped = CYRILLIC_TO_LATIN[ch];
    out += mapped ?? ch;
  }
  return out;
}
